import {LitElement} from 'lit';
import { customElement} from 'lit/decorators.js';
import "@/components/announcement/announcement.scss"

/**
 * An example element.
 *
 * @slot - This element has a slot
 */
@customElement('sbk-announcement')
export class SbkaAnouncement extends LitElement {
    protected createRenderRoot() {
        return this;
    }
}
